import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CmsService, Page } from '@spartacus/core';
import { filter, take, takeUntil } from 'rxjs/operators';
import { LazyLoadingService, LocationService } from '@seb/web-common/core/services';

@Component({
  template: '',
  standalone: true
})
export class AbstractRecipeCategoryPageComponent implements OnInit, OnDestroy {
  protected readonly destroy$: Subject<void> = new Subject();
  protected eagerLoadingSlot: string;
  protected eagerLoadingLimit = 2;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-template'].filter(Boolean).join(' ');
  }

  constructor(
    protected cmsService: CmsService,
    protected lazyLoadingService: LazyLoadingService,
    protected locationService: LocationService
  ) {}

  ngOnInit(): void {
    this.cmsService
      .getCurrentPage()
      .pipe(
        filter((p) => !!p),
        takeUntil(this.destroy$)
      )
      .subscribe((page: Page) => {
        this.locationService.replaceUrl(page['canonicalUrl']);
      });

    if (this.eagerLoadingSlot) {
      this.handleEagerLoadingUids();
    } else {
      this.lazyLoadingService.setFirstUids([]);
    }
  }

  private handleEagerLoadingUids() {
    this.cmsService
      .getContentSlot(this.eagerLoadingSlot)
      .pipe(take(1))
      .subscribe((slotData) => {
        const uids: string[] =
          slotData?.components
            ?.filter((cmpData) => cmpData.typeCode !== 'AnchorBlocComponent')
            .slice(0, this.eagerLoadingLimit)
            .map((cmpData) => cmpData.uid) || [];
        this.lazyLoadingService.setFirstUids(uids);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
